<app-check-browser-modal></app-check-browser-modal>

<app-login-form *ngIf="!authenticated" (onAuthenticated)="onAuthenticated($event)"></app-login-form>
